/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 02/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';
import { isNullish } from '@/wpt-lib/utils/isNullish';

const ExistingResearch = ({
    targetResearchSpendForThisYear,
    researchMaster,
    existingResearchProjectExternalFunded,
}: Partial<{
    targetResearchSpendForThisYear: number;
    researchMaster: {
        researchMasterAutoCompleteValue: string;
        incomeCategory: string;
        projectEndDate: string;
        fundingOrg: string;
        existingLeadResearcher: string;
    };
    existingResearchProjectExternalFunded: boolean;
}>) => (
    <>
        <Row widths={[80, 20]}>
            <ValueCell label="Project name" value={researchMaster?.researchMasterAutoCompleteValue} />
            <ValueCell label="Project End Date" value={researchMaster?.projectEndDate} />
        </Row>
        {!isNullish(existingResearchProjectExternalFunded) && (
            <Row>
                <ValueCell
                    single
                    label="Project has external funding"
                    value={existingResearchProjectExternalFunded ? 'Yes' : 'No'}
                />
            </Row>
        )}
        <Row>
            <ValueCell label="Targeted research spending for this year" value={targetResearchSpendForThisYear} />
            <ValueCell label="Funding Organisation" value={researchMaster?.fundingOrg} />
        </Row>
        <Row>
            <ValueCell label="Income Category" value={researchMaster?.incomeCategory} />
        </Row>
        <Row>
            <ValueCell single label="Lead Researcher" value={researchMaster?.existingLeadResearcher} />
        </Row>
    </>
);

export default ExistingResearch;
